import type { AdminUserSessionContext } from '../../../viewmodels/AdminViewModels';

// A support-only admin (no other permissions) lands on the one page they can use, instead of /accounts.
export function getAdminLandingPath(userSession?: AdminUserSessionContext): string {
	const hasAnyPermission = Object.keys(userSession?.permissions || {}).length > 0;
	return !hasAnyPermission && userSession?.canAccessSupport ? '/support' : '/accounts';
}
